/**
 * Locked kody.codes homepage copy (hero plus the early-scroll sections).
 * Keep these strings exact. Do not invent positioning or swap in synonyms.
 */

export const landingHeroHeadlineLead = 'Your agents\u2019 '
export const landingHeroHeadlineEmphasis = 'cloud'
export const landingHeroHeadline = `${landingHeroHeadlineLead}${landingHeroHeadlineEmphasis}`

export const landingHeroSubheadLead =
	'You shouldn\u2019t have to start over in '
export const landingHeroSubheadEmphasis = 'every agent.'
export const landingHeroSubheadTail = ''
export const landingHeroLead =
	'One home for packages, secrets, memory, and jobs, so what you build in Cursor still runs in Claude.'
export const landingHeroPrimaryCta = 'Connect your agent'
export const landingHeroSecondaryCta = 'See how it works'

export const landingPrimitivesIntroLead =
	'Kody gives your agents a shared set of primitives.'
export const landingPrimitivesMoreLead = 'Want the full picture?'
export const landingPrimitivesMoreLink = 'What is Kody?'

export const landingHomePrimitives = [
	{
		id: 'memory',
		word: 'memory',
		body: 'Facts without a better home, like project nicknames or personal context, that your connected agents can retrieve.',
	},
	{
		id: 'secrets',
		word: 'secrets',
		body: 'Keys and tokens the model never sees. Your agent can use a connection without reading the credential.',
	},
	{
		id: 'packages',
		word: 'packages',
		body: 'Reusable code with typed inputs and documented defaults. Keep how a task gets done in the package, ready for any connected agent to run.',
	},
	{
		id: 'triggers',
		word: 'triggers',
		body: 'Subscriptions, emails, webhooks, and schedules that wake packages you own — no chat left open.',
	},
	{
		id: 'integrations',
		word: 'integrations',
		body: 'Signed-in connections to the tools you already use (GitHub, Discord, Google, and more), reusable from any agent.',
	},
	{
		id: 'apps',
		word: 'apps',
		body: 'A hosted page a package serves, so the work is something you open instead of another turn in chat.',
	},
] as const

export type LandingHomePrimitive = (typeof landingHomePrimitives)[number]

export const landingVsHeading = 'Not another chat. Not another gateway.'

export const landingVsItems = [
	{
		kicker: 'Skills files and copy-paste.',
		body: 'A skill in one agent stays stuck there. On Kody it becomes a package you run from Cursor, Claude, Codex, or ChatGPT.',
	},
	{
		kicker: 'Multi-model tabs and routers.',
		body: 'Switching models is not the same as keeping the work. Kody holds the memory, secrets, and packages those models call.',
	},
	{
		kicker: 'MCP gateways.',
		body: 'Great at connecting tools. Kody is where the useful work becomes software you own, schedule, and reuse.',
	},
] as const

export const landingCompareWithoutTitle = 'Without Kody'
export const landingCompareWithTitle = 'With Kody'
export const landingCompareCaption = 'Ask once. Save it. Trigger it.'

export const landingCompareWithoutItems = [
	'Re-teach the agent each session',
	'Re-wire secrets per host',
	'Rebuild the same automation when you change agents',
] as const

export const landingCompareWithItems = [
	'Memory and packages live in one home',
	'Secrets stay usable without landing in the prompt',
	'Trigger the same package from cron, webhook, email, or any connected agent',
] as const

export const landingInviteHeadingLead = 'Give your services a '
export const landingInviteHeadingEmphasis = 'home'
export const landingInviteGuestLead =
	'Create a free account and connect a service you already use.'
export const landingInviteSignedInLead =
	'You\u2019re in. Connect a service you already use and start saving packages.'
